import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const sponsoredBrand = PropTypes.shape({
  id: PropTypes.string.isRequired,
  brandId: PropTypes.string.isRequired,
  brandName: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ctaLinkUrl: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  colorScheme: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.string).isRequired,
  mediaAssets: PropTypes.arrayOf(PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
    slotId: PropTypes.string.isRequired,
  })),
  status: PropTypes.bool.isRequired,
  busy: PropTypes.bool.isRequired,
  error: PropTypes.string,
});
